import http from '.'

export default class Services {
  constructor() {
    this._http = http
  }

  handlingError(error) {
    try {
      // O interceptor de resposta (services/index.js) ja normalizou a falha
      // para { success:false, status, message, errors, data }; devolve-la
      // intacta e o que todo consumidor espera. Este guard e necessario porque
      // o ramo legado abaixo dispara com base em `error.data` — e desde que o
      // 422 do carrinho publico passou a carregar data ({codigo, saldo, ...}),
      // um erro ja tratado caia nele e era rejeitado como `undefined`,
      // apagando a mensagem que o backend havia mandado.
      if (error && error.success === false && 'message' in error) {
        return Promise.reject(error)
      }

      if (!error.data) {
        if (typeof error === 'string' && error.lastIndexOf('Network') !== -1)
          return Promise.reject(error)
        else {
          return Promise.reject(error)
        }
      }
      const { statusText, data } = error
      return Promise.reject(data.error || statusText)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getAPI(requestUrl, params) {
    try {
      let response = await http.get(requestUrl, { params })
      return response?.data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async postAPI(requestUrl, payload) {
    try {
      const response = await http.post(requestUrl, { ...payload })
      const { data } = response
      return data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async updateAPI(payload, id) {
    try {
      const { data } = await http.put(`${this.resource}/${id}`, {
        ...payload,
      })
      return data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async patchAPI(requestUrl, payload, id) {
    try {
      const { data } = await http.patch(`${requestUrl}/${id}`, {
        ...payload,
      })
      return data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async deleteAPI(id) {
    try {
      const { data } = await http.delete(`${this.resource}/${id}`)
      return data
    } catch (e) {
      return this.handlingError(e)
    }
  }
}
